export const config = {
  baseUrl: process.env.REACT_APP_GRAPHQL as string,
  sportsUrl: process.env.REACT_APP_REST_API as string,
  baseUrlAxios: ''
}
